module.exports = new __parcel__URL__("shortcuts-preview.8780e9d0.svg").toString();